import {ProjectBuilderData} from "@tool/Builder/Builder.types";
import useBuilderStore from "@tool/store/useBuilderStore";


export default function BuilderInitUser(projectData: ProjectBuilderData): void {

    const {
        project,
        projectUrls,
        projectParameters,
        projectTemplates,
        projectBuilderSettings,
        projectPermissions,
    } = useBuilderStore();

    project.value = projectData.project;
    projectUrls.value = projectData.urls;
    projectTemplates.value = projectData.templates;
    projectBuilderSettings.value = projectData.settings;
    projectPermissions.value = projectData.permissions;

    for (let i = 0; i < projectData.parameters.length; i++) {
        projectParameters.value[projectData.parameters[i].type].push(projectData.parameters[i]);
    }
}